<template>
  <b-modal id="modal-4" size="lg" :key="iteration">
    <!--Body-->
    <!-- <div class="modal-body"> -->
    <template slot="default">
      <b-row>
        <b-col lg="12">
          <!-- <b-card>
        <div slot="header">User Profile</div>-->
          <b-form>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Quantity</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      :class="{
                        my_warning: n_user.transaction_edit.Quantity.$error
                      }"
                      v-model="n_user.transaction_edit.Quantity"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="Quantity"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Description</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      required
                      v-model="n_user.transaction_edit.Description"
                      placeholder="Required"
                      autocomplete="off"
                      type="text"
                      id="Description"
                      v-on:change.native="addDirtyField"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </template>
    <!-- </div> -->

    <!-- Footer-->
    <template slot="modal-footer">
      <div>
        <b-alert
          class="btn mr-4 mt-2"
          :show="dismiss2CountDown"
          fade
          variant="danger"
          :dismissed="(dismiss2Countdown = 0)"
          @dismiss-count-down="countDown2Changed"
        >
          Your information could not be saved. Check all fields carefully.
          <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
        </b-alert>
      </div>
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="SaveCanceled"
          aria-label="Close"
          >Cancel</b-button
        >
        <b-button
          class="mr-0"
          size="md"
          variant="primary"
          type="submit"
          :disabled="isClean"
          @click="SaveConfirmed"
        >
          <i class="fa fa-save"></i>
          Save
        </b-button>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required, integer } from "vuelidate/lib/validators";
export default {
  computed: {
    ...mapState(["saveOp", "global", "n_user"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  created() {
    //console.log(this.$store.state.n_user.transaction_edit);
  },
  mounted() {},
  props: {
    //component_object: { type: Object },
    myIteration: Number
  },
  data() {
    return {
      //current_transaction: this.component_object,
      dirtyFields: [],
      isSaving: false,
      isSaved: false,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      iteration: this.myIteration
    };
  },
  methods: {
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
      }
    },
    addEditedBy() {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "EnteredBy"
      );
      this.dirtyFields.push({
        FieldName: "EnteredBy",
        FieldValue: this.$store.state.n_user.n_current_user.UserProfileID
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    async SaveConfirmed() {
      //this.addEditedBy();
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        // this.$store.state.saveOp.localDirtyFields.push({
        //   FieldName: "EnteredBy",
        //   FieldValue: this.$store.state.n_user.n_current_user.UserProfileID
        // });
        this.addEditedBy();
        this.$store.state.saveOp.localUrl = "/User/SaveTransaction/";
        this.$store.state.saveOp.localVariableName = "_pt";
        this.$store.state.saveOp.localVariableObject = this.$store.state.n_user.transaction_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "PointTransactionID";
        this.$store.state.saveOp.localReturnObject = "SaveTransactionResult";
        await this.$store.dispatch("saveOp/BuildSaveOperation");
        await this.$store.dispatch("saveOp/EmitSave");
        this.dirtyFields = [];
        this.$store.state.saveOp.DestroySaveOperation;
        this.$emit("filterList");
        this.$bvModal.hide("modal-4");
      }
    },
    SaveCanceled() {
      this.dirtyFields = [];
      this.$store.state.saveOp.DestroySaveOperation;
      this.$bvModal.hide("modal-4");
      this.dismiss2CountDown = 0;
      this.$emit("filterList");
    }
  },
  validations: {
    n_user: {
      transaction_edit: {
        Quantity: {
          required,
          integer
        },
        Description: {
          required
        }
      }
    }
  },
  updated() {}
};
</script>
<style scoped>
.myclass > div {
  position: absolute !important;
  top: -10px !important;
  left: -10px !important;
  background-color: yellow !important;
}

.myclass > .modal-dialog > .modal-content {
  background-color: red !important;
}
.my_warning {
  color: red;
  border-color: red;
}
</style>
